import {isArcGisWmsLayer} from './isArcGisLayer'
import axios from 'axios'
import $ from 'jquery'

const ArcGisWmsQuery = map => {
  const arcGisWmsQuery = options => {
    var extent = options.extent.join(',')
    var coordinate = options.coordinate
    var srs = options.srsName
    var layerName = options.layerName
    var featureCount = options.featureCount

    var params = {
      request: 'GetFeatureInfo',
      version: '1.1.1',
      format: 'image/png',
      BBOX: extent,
      SRS: srs,
      x: 1,
      y: 1,
      WIDTH: 1,
      HEIGHT: 1,
      QUERY_LAYERS: layerName,
      FEATURE_COUNT: featureCount
    }

    if (options.params && options.params.LAYERDEFS) {
      params.LAYERDEFS = options.params.LAYERDEFS
    }

    if (options.params && options.params.access_token) {
      params.access_token = options.params.access_token
    }

    var url = options.baseUrl

    return axios
      .get(url, {
        params,
        responseType: 'document' //XML DOM tree
      })
      .then(response => {
        const geoJSON = {
          type: 'FeatureCollection',
          features: []
        }
        let feature

        $(response.data)
          .find('FIELDS')
          .each(function() {
            feature = {
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'Point',
                coordinates: coordinate
              }
            }

            $.each(this.attributes, function(i, attr) {
              attr.value = attr.value === 'Null' ? '' : attr.value
              feature.properties[attr.name] = attr.value
            })
            geoJSON.features.push(feature)
          })

        return geoJSON
      })
  }

  const query = (layer, queryOptions) => {
    const srsName = map
      .getView()
      .getProjection()
      .getCode()
    return arcGisWmsQuery({
      baseUrl: layer.metadata.baseUrl || layer.source.url,
      params: layer.source.params,
      layerName: layer.metadata.layerName || layer.source.params.LAYERS,
      srsName: srsName,
      layer: layer,
      extent: queryOptions.extent,
      coordinate: queryOptions.coordinate,
      featureCount: layer.metadata.featureCount || 1
    }).catch(err => {
      console.error('ArcGisWmsQuery: Failed to query', layer.name, err)
      return []
    })
  }

  const isLayerSupported = layer =>
    isArcGisWmsLayer(layer) &&
    (layer.source.type === 'TileWMS' || layer.source.type === 'ImageWMS')

  return {
    query,
    isLayerSupported
  }
}

export default ArcGisWmsQuery
